<!--
 * @Author: your name
 * @Date: 2021-04-15 16:59:26
 * @LastEditTime: 2024-01-26 15:53:41
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ope\src\views\Login.vue
-->
<template>
  <div class="iframe_wrapper"></div>
</template>
<script>
import { callBackUrl, gateway, epecBaseUrlSsologin } from '../../api/config';

export default {
  data() {
    return {
      baseUrl: `${epecBaseUrlSsologin}?action=logout&encryptedCallBack=`,
      gateway: `${gateway}/ssoLogin/callback?from=WEB_SITE`,
      afterLoginUrl: `&afterLoginUrl=${callBackUrl}`,
    };
  },

  computed: {
    epecLoginUrl() {
      // 解码用 decodeURIComponent(str)
      // 编码用 encodeURIComponent(str)
      return (
        this.baseUrl +
        encodeURIComponent(
          this.gateway + this.afterLoginUrl + (this.$route.query.url || '')
        )
      );
      // return this.baseUrl + encodeURIComponent(this.gateway + this.afterLoginUrl);
    },
  },
  created() {},
  mounted() {
    // localStorage.clear();
    // const form = document.createElement('form');
    // form.action = this.epecLoginUrl;
    // form.target = '_self';
    // form.method = 'GET';
    // document.body.appendChild(form);
    // form.submit();

    const epecUrlToRedirectAfterLogout = this.$cookies.get(
      'epecUrlToRedirectAfterLogout'
    );

    if (epecUrlToRedirectAfterLogout) {
      window.open(
        `${decodeURIComponent(
          epecUrlToRedirectAfterLogout
        )}&afterUrl=${encodeURIComponent(callBackUrl)}`,
        '_self'
      );
      return;
    }
    window.open(this.epecLoginUrl, '_self');
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.iframe_wrapper {
  width: 100%;
  height: 100vh;
  .iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
